import { gql } from "@apollo/client";

export const LIST_NOTIFICATIONS = gql(`
    query UserNotifications(
      $where: UserWhereUniqueInput!
      $skip: Float!
      $take: Float!
    ) {
      user(where: $where) {
        id
        countNotification
        userNotifications(skip: $skip, take: $take) {
          id
          body_fr
          body_en
          createdAt
          data
          read
          title_fr
          title_en
          type
          receiverId
        }
      }
    }
  `);

export const DELETE_NOTIFICATIONS = gql(`
    mutation DeleteManyNotification($where: NotificationWhereInput) {
      deleteManyNotification(where: $where) {
        count
      }
    }
  `);

export const VIEW_NOTIFICATION = gql(`
    mutation ViewNotification(
      $data: NotificationUpdateInput!
      $where: NotificationWhereUniqueInput!
    ) {
      updateOneNotification(data: $data, where: $where) {
        id
        read
        body_en
        body_fr
        createdAt
        data
        receiverId
        title_en
        title_fr
        type
      }
    }
  `);

export const DELETE_NOTIFICATION = gql(`
    mutation DeleteOneNotification($where: NotificationWhereUniqueInput!) {
      deleteOneNotification(where: $where) {
        id
      }
    }
  `);

export const NEW_NOTIFICATION = gql(`
  subscription NewNotificationSubcription($receiverId: Float!) {
    newNotification(receiverId: $receiverId) {
      body_en
      body_fr
      createdAt
      data
      id
      read
      receiverId
      title_en
      title_fr
      type
    }
  }
`);
